import styled from 'styled-components';
import { spacing } from '../../constants/spacing.js';
import { styles } from '../../constants/styles.js';
import { boxStyles } from '../../Box/styles.js';
import { px2rem } from '../../utils/helpers/style.js';
import { boxPropExclusions } from '../../Box/props.js';

var wrapper = /*#__PURE__*/styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !boxPropExclusions.has(prop);
  }
}).withConfig({
  displayName: "styles__wrapper",
  componentId: "sc-17bx9xp-0"
})(["color:", ";padding:", ";display:inline-flex;align-items:center;justify-content:center;position:relative;transform:translate3d(", ",0,0);transition:transform ", ";transition-timing-function:", ";", ""], function (props) {
  return props.$color;
}, spacing.xxxs, function (props) {
  return props.$slide ? px2rem(4) : 0;
}, styles.transition.timing.slowest, styles.transition["function"].base, boxStyles);

// Add a small delta to the dasharray to prevent small gap in visible circle
var delta = 0.01;
var animatedCircle = /*#__PURE__*/styled.svg.withConfig({
  displayName: "styles__animatedCircle",
  componentId: "sc-17bx9xp-1"
})(["position:absolute;height:100%;width:100%;top:0;left:0;stroke-dasharray:", ";stroke-dashoffset:", ";transition:stroke-dashoffset ", ";transition-timing-function:", ";"], 1 + delta, function (props) {
  return props.$visible ? 0 : 1 + delta;
}, styles.transition.timing.slowest, styles.transition["function"].base);

export { animatedCircle, wrapper };
